<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['container.no']" placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-select v-model="query['containerType.id']" :options="containerTypes" placeholder="business.label.containerType" @change="refresh"/>
        <vxe-switch v-model="query.available" close-label="禁用" open-label="可用" size="medium" @change="refresh"/>
        <vxe-switch v-model="query.physical" close-label="虚拟" open-label="物理" size="medium" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.no"/>
        <vxe-column field="name" title="business.label.name"/>
        <vxe-column field="containerType.name" title="business.label.containerType"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="physical" title="business.label.physical" width="60"/>
        <vxe-column field="carrier.name" title="business.label.carrier"/>
        <vxe-column field="currentPosition.no" title="business.label.currentPosition"/>
        <vxe-column field="lastPosition.no" title="business.label.lastPosition"/>
        <vxe-column field="taskId" title="business.label.taskId"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:operationTypes}" field="operationType" title="business.label.operationType" width="70"/>
        <vxe-column field="traceNo" title="business.label.traceNo"/>
        <vxe-column field="pickingOrder.no" title="business.label.pickingOrder"/>
        <vxe-column field="destination.no" title="business.label.destination"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <container-editor ref="editor" :container-types="containerTypes" @success="refresh"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { getEnums, getOptions } from '@/utils/util'
import ContainerEditor from '@/views/basedata/container/ContainerEditor.vue'

export default {
  name: 'ContainerMaintain',
  components: { ContainerEditor },
  data() {
    return {
      loading: false,
      data: [],
      query: { 'container.no': '', available: true, 'containerType.id': undefined, physical: true },
      operationTypes: [],
      containerTypes: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    findAll('containerTypeFactory').then(res => {
      if (res.success) {
        this.containerTypes = getOptions(res.result)
      }
      return getEnums('OperationType')
    }).then(result => {
      this.operationTypes = result
    })
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('containerFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { 'container.no': '', available: true, 'containerType.id': undefined, physical: true }
      this.refresh()
    },
    add() {
      this.$refs.editor.open()
    }
  }
}
</script>